<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Parâmetros Gerais</b>
						</h3>
					</div>

					<div class="box-body">
						<div class="nav-tabs-custom">
							<ul class="nav nav-tabs">
								<li class="active">
									<a href="#tab_1" data-toggle="tab" aria-expanded="true">Regulador</a>
								</li>
								<li class>
									<a href="#tab_2" data-toggle="tab" aria-expanded="false">Marcador</a>
								</li>
								<li class>
									<a href="#tab_3" data-toggle="tab" aria-expanded="false">Prestador</a>
								</li>
								<li class>
									<a href="#tab_4" data-toggle="tab" aria-expanded="false">Administrador</a>
								</li>
							</ul>
							<div class="tab-content">
								<div class="tab-pane active" id="tab_1">
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label>Dias de visão das agendas para o regulador</label>
												<select v-model="dados.dias_visao_regulador" class="form-control">
													<option value>--Selecione--</option>
													<option value="5">5</option>
													<option value="10">10</option>
													<option value="15">15</option>
													<option value="20">20</option>
													<option value="25">25</option>
													<option value="30">30</option>
													<option value="35">35</option>
													<option value="40">40</option>
													<option value="45">45</option>
												</select>
											</div>
										</div>

										<div class="col-md-12">
											<div class="form-group">
												<label>Permite enviar procedimentos agrupados para a regulação?</label>
												<select v-model="dados.procedimentos_agrupados_regulador" class="form-control">
													<option value>--Selecione--</option>
													<option value="1">SIM</option>
													<option value="0">NÃO</option>
												</select>
											</div>
										</div>

										<div class="col-md-12">
											<div :class="{'form-group': true, 'has-error':errors.has('abertura_regulador')}">
												<label>Horário de abertura</label>
												<input v-model="dados.horario_abertura_regulador" name="abertura_regulador" class="form-control" type="time" v-validate="'required'">
												<span v-show="errors.has('abertura_regulador')" class="help-block">Preencha o horário de abertura.</span>
											</div>
										</div>

										<div class="col-md-12">
											<div :class="{'form-group': true, 'has-error':errors.has('fechamento_regulador')}">
												<label>Horário de fechamento</label>
												<input v-model="dados.horario_fechamento_regulador" name="fechamento_regulador" class="form-control" type="time" v-validate="'required' + (dados.horario_fechamento_regulador <= dados.horario_abertura_regulador? '|is:null' : '')">
												<span v-show="errors.has('fechamento_regulador')" class="help-block">Preencha o horário de fechamento também, sempre maior que o de abertura.</span>
											</div>
										</div>

									</div>
								</div>

								<div class="tab-pane" id="tab_2">
									<div class="row">
										<div class="col-md-12">
											<div class="form-group">
												<label>Habilita Marcação (PPI)?</label>
												<select v-model="dados.habilita_ppi_marcador" class="form-control">
													<option value>--Selecione--</option>
													<option value="1">SIM</option>
													<option value="0">NÃO</option>
												</select>
											</div>
										</div>

										<div class="col-md-12">
											<div class="form-group">
												<label>Habilita Marcação (Demais)?</label>
												<select v-model="dados.habilita_demais_marcador" class="form-control">
													<option value>--Selecione--</option>
													<option value="1">SIM</option>
													<option value="0">NÃO</option>
												</select>
											</div>
										</div>
										<div class="col-md-12">
											<div class="form-group">
												<label>Dias de visão das agendas para o marcador</label>
												<input v-model="dados.dias_visao_marcador" class="form-control" type="number">
											</div>
										</div>

										<div class="col-md-12">
											<div class="form-group">
												<label>Dias de visão de procedimentos agrupados</label>
												<input v-model="dados.dias_visao_agrupados_marcador" class="form-control" type="number">
											</div>
										</div>

										<div class="col-md-12">
											<div class="form-group">
												<label>Informar obrigatoriamente os diagnósticos (CID-10) na marcação?</label>
												<select v-model="dados.obriga_diagnosticos_marcador" class="form-control">
													<option value>--Selecione--</option>
													<option value="1">SIM</option>
													<option value="0">NÃO</option>
												</select>
											</div>
										</div>

										<div class="col-md-12">
											<div :class="{'form-group': true, 'has-error':errors.has('abertura_marcador')}">
												<label>Horário de abertura</label>
												<input v-model="dados.horario_abertura_marcador" name="abertura_marcador" class="form-control" type="time" v-validate="'required'">
												<span v-show="errors.has('abertura_marcador')" class="help-block">Preencha o horário de abertura.</span>
											</div>
										</div>

										<div class="col-md-12">
											<div :class="{'form-group': true, 'has-error':errors.has('fechamento_marcador')}">
												<label>Horário de fechamento</label>
												<input v-model="dados.horario_fechamento_marcador" name="fechamento_marcador" class="form-control" type="time" v-validate="'required' + (dados.horario_fechamento_marcador <= dados.horario_abertura_marcador ? '|is:null' : '')">
												<span v-show="errors.has('fechamento_marcador')" class="help-block">Preencha o horário de fechamento também, sempre maior que o de abertura.</span>
											</div>
										</div>

									</div>
								</div>

								<div class="tab-pane" id="tab_3">
									<div class="row">
										<div class="col-md-12">
											<div :class="{'form-group': true, 'has-error':errors.has('abertura_prestador')}">
												<label>Horário de abertura</label>
												<input v-model="dados.horario_abertura_prestador" name="abertura_prestador" class="form-control" type="time" v-validate="'required'">
												<span v-show="errors.has('abertura_prestador')" class="help-block">Preencha o horário de abertura.</span>
											</div>
										</div>

										<div class="col-md-12">
											<div :class="{'form-group': true, 'has-error':errors.has('fechamento_prestador')}">
												<label>Horário de fechamento</label>
												<input v-model="dados.horario_fechamento_prestador" name="fechamento_prestador" class="form-control" type="time" v-validate="'required' + (dados.horario_fechamento_prestador <= dados.horario_abertura_prestador? '|is:null' : '')">
												<span v-show="errors.has('fechamento_prestador')" class="help-block">Preencha o horário de fechamento também, sempre maior que o de abertura.</span>
											</div>
										</div>

									</div>
								</div>

								<div class="tab-pane" id="tab_4">
									<div class="row">
										<div class="col-md-12">
											<div :class="{'form-group': true, 'has-error':errors.has('abertura_admin')}">
												<label>Horário de abertura</label>
												<input v-model="dados.horario_abertura_admin" name="abertura_admin" class="form-control" type="time" v-validate="'required'">
												<span v-show="errors.has('abertura_admin')" class="help-block">Preencha o horário de abertura.</span>
											</div>
										</div>

										<div class="col-md-12">
											<div :class="{'form-group': true, 'has-error':errors.has('fechamento_admin')}">
												<label>Horário de fechamento</label>
												<input v-model="dados.horario_fechamento_admin" name="fechamento_admin" class="form-control" type="time" v-validate="'required' + (dados.horario_fechamento_admin <= dados.horario_abertura_admin? '|is:null' : '')">
												<span v-show="errors.has('fechamento_admin')" class="help-block">Preencha o horário de fechamento também, sempre maior que o de abertura.</span>
											</div>
										</div>

									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<button @click="salvar()" class="btn btn-primary pull-right" type="button">
									<i class="fa fa-save"></i> Salvar
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import moment from 'moment';
export default {
	filters: {},
	data: () => ({
		dados: {
			dias_visao_regulador: 45,
			procedimentos_agrupados_regulador: 0,
			procedimentos_nao_pactuados_regulador: 0,
			horario_abertura_regulador: '',
			horario_fechamento_regulador: '',
			habilita_ppi_marcador: 1,
			habilita_demais_marcador: 1,
			dias_visao_marcador: 10,
			dias_visao_agrupados_marcador: 10,
			dias_visao_retorno_marcador: 10,
			obriga_diagnosticos_marcador: 0,
			horario_abertura_marcador: '',
			horario_fechamento_marcador: '',
			horario_abertura_prestador: '',
			horario_fechamento_prestador: '',
			horario_abertura_admin: '',
			horario_fechamento_admin: ''
		}
	}),
	mounted() {
		this.getParametros();
	},
	methods: {
		getParametros() {
			this.$store.commit("TOGGLE_LOADING");
			axios
				.get(
					`${
            this.$store.state.serverURI
          }/api/administracao/parametros/getParametros`,
					this.$store.getters.getHeaderAuth
				)
				.then(response => {
					this.dados.dias_visao_regulador = response.data.dias_visao_regulador;
					this.dados.dias_visao_marcador = response.data.dias_visao_marcador;
					this.dados.dias_visao_retorno_marcador = response.data.dias_visao_retorno_marcador;
					this.dados.dias_visao_agrupados_marcador = response.data.dias_visao_agrupados_marcador;
					this.dados.horario_abertura_marcador = response.data.horario_abertura_marcador ? moment(response.data.horario_abertura_marcador, "HH:mm:ss").format('HH:mm') : '';
					this.dados.horario_fechamento_marcador = response.data.horario_fechamento_marcador ? moment(response.data.horario_fechamento_marcador, "HH:mm:ss").format('HH:mm') : '';
					this.dados.horario_abertura_regulador = response.data.horario_abertura_regulador ? moment(response.data.horario_abertura_regulador, "HH:mm:ss").format('HH:mm') : '';
					this.dados.horario_fechamento_regulador = response.data.horario_fechamento_regulador ? moment(response.data.horario_fechamento_regulador, "HH:mm:ss").format('HH:mm') : '';
					this.dados.horario_abertura_prestador = response.data.horario_abertura_prestador ? moment(response.data.horario_abertura_prestador, "HH:mm:ss").format('HH:mm') : '';
					this.dados.horario_fechamento_prestador = response.data.horario_fechamento_prestador ? moment(response.data.horario_fechamento_prestador, "HH:mm:ss").format('HH:mm') : '';
					this.dados.horario_abertura_admin = response.data.horario_abertura_admin ? moment(response.data.horario_abertura_admin, "HH:mm:ss").format('HH:mm') : '';
					this.dados.horario_fechamento_admin = response.data.horario_fechamento_admin ? moment(response.data.horario_fechamento_admin, "HH:mm:ss").format('HH:mm') : '';
					this.$store.commit("TOGGLE_LOADING");
				})
				.catch(error => {
					console.log(error);
				});
		},
		salvar() {
			this.$validator.validate().then(result => {
					if (result) {
						axios
							.post(
								`${this.$store.state.serverURI}/api/administracao/parametros/update`,
								this.dados,
								this.$store.getters.getHeaderAuth
							)
							.then(response => {
								this.$swal({
									type: "success",
									title: "Parâmetros atualizados com sucesso!",
									showConfirmButton: false,
									timer: 1500
								});
							})
							.catch(error => {
								var erros = error.response.data.message + " ";
								for (var erro of Object.values(error.response.data.errors)) {
									erros += erro + " \n";
								}
								this.$swal({
									type: "error",
									title: "Houve uma falha!",
									text: erros
								});
							});
					}
				});
			}
		},
		watch: {},
		components: {}
	};
</script>

<style>
.erro-validacao {
	color: #d73925;
}
</style>



// WEBPACK FOOTER //
// index.vue?0ab5633e